import config from '../Configs';

// Wallet types matching
export const WalletType = config.NEW_PLAT ? {
    Rollover: 1,
    Unused: 2,
    Used: 3,
    Bonus: 4,
    BonusCampaign: 17
} : {
    Unused: 1,
    Used: 2,
    Bonus: 12,
    Wagering: 14,
    SportBonus: 16,
    BonusCampaign: 17
}

Object.freeze(WalletType);

export default WalletType;